import React, { useContext, useEffect, useState } from "react";

import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import ErrorIcon from "@material-ui/icons/Error";
import EventBusyIcon from "@material-ui/icons/EventBusy";
import AccessAlarmsIcon from "@material-ui/icons/AccessAlarms";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import CheckIcon from "@material-ui/icons/Check";
import VisibilityIcon from "@material-ui/icons/Visibility";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import RefreshIcon from "@material-ui/icons/Refresh";
import SendIcon from "@material-ui/icons/Send";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import CircularProgress from "@material-ui/core/CircularProgress";
import Tooltip from "@material-ui/core/Tooltip";
import TimerIcon from "@material-ui/icons/Timer";
import Checkbox from "@material-ui/core/Checkbox";
import { Button, Grid } from "@material-ui/core";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";

import Swal from "sweetalert2";

import { useHistory } from "react-router-dom";

import TableDefault from "../../components/grid/TableDefault";
import CNDSendEmail from "./modal/CNDSendEmail";
import {
  findCNDAgendaCliente,
  refreshCNDAgendaCliente,
} from "../../repository/ERP/pub/CNDAgendaClienteService";
import {
  findCNDConfig,
  updateCNDConfig,
} from "../../repository/ERP/pub/CNDConfigService";
import MaskService from "../../utils/mask/maskService";
import { QueryParamsContext } from "../../context/QueryParamsContext";
import { notify } from "../../utils/notify";
import SearchInput from "../../components/basics/SearchInput";
import Loading from "../../components/basics/Loading";
import filterTable from "../../utils/filterTable";
import "./CND.css";
import { PulseIcon } from "./styles/Cnd";
import CNDFailure from "./modal/CNDFailure";

const CNDTabControle = ({ rowsPerPage }) => {
  const [openCndFailure, setOpenCndFailure] = useState(false);
  const [arrCndFailures, setArrCndFailures] = useState([]);
  const [openSendEmail, setOpenSendEmail] = useState(false);
  const [filesSendEmail, setFilesSendEmail] = useState({});
  const [emailToSendEmail, setEmailToSendEmail] = useState("");
  const [dataRows, setDataRows] = useState([]);
  const [dataRowsFilter, setDataRowsFilter] = useState([]);
  const [envioAutomaticoCheck, setEnvioAutomaticoCheck] = useState(false);
  const [acessoClienteCheck, setAcessoClienteCheck] = useState(false);
  const [cndPositivaCheck, setCndPositivaCheck] = useState(false);
  const [cndNegativaCheck, setCndNegativaCheck] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [loadingSendAuto, setLoadingSendAuto] = useState(false);
  const [loadingAccessPass, setLoadingAccessPass] = useState(false);
  const [loadingCheckCndPositiva, setLoadingCheckCndPositiva] = useState(false);
  const [loadingCheckCndNegativa, setLoadingCheckCndNegativa] = useState(false);
  const [loadingScreen, setLoadindScreen] = useState(false);
  const [refreshData, setRefreshData] = useState(false);
  const [runTimeout, setRunTimeout] = useState(false);
  const [initialPage, setInitialPage] = useState(0);
  const { queryParams } = useContext(QueryParamsContext);
  const { push } = useHistory();

  useEffect(() => {
    setRunTimeout(true);

    if (runTimeout) return;

    setTimeout(() => {
      setRunTimeout(false);

      setRefreshData((current) => !current);
    }, 300000);
  }, [refreshData, runTimeout]);

  useEffect(() => {
    const getConfig = async () => {
      setLoadingSendAuto(true);
      setLoadingAccessPass(true);
      setLoadingCheckCndNegativa(true);
      setLoadingCheckCndPositiva(true);
      try {
        const { data: sendAutomatic } = await findCNDConfig(
          queryParams.empresa_cnpj,
          "email_automatico"
        );

        const { data: accessPass } = await findCNDConfig(
          queryParams.empresa_cnpj,
          "acesso_cliente_qyon_pass"
        );

        const { data: cndNegative } = await findCNDConfig(
          queryParams.empresa_cnpj,
          "acesso_cnd_negativa"
        );

        const { data: cndPositive } = await findCNDConfig(
          queryParams.empresa_cnpj,
          "acesso_cnd_positiva"
        );

        if (sendAutomatic && sendAutomatic.value) {
          setEnvioAutomaticoCheck(true);
        }

        if (accessPass && accessPass.value) {
          setAcessoClienteCheck(true);
        }

        if (cndNegative && cndNegative.value) {
          setCndNegativaCheck(true);
        }

        if (cndPositive && cndPositive.value) {
          setCndPositivaCheck(true);
        }
      } catch (error) {
        console.error("error useEffect getConfig CNDTabControle", error);
      } finally {
        setLoadingSendAuto(false);
        setLoadingAccessPass(false);
        setLoadingCheckCndNegativa(false);
        setLoadingCheckCndPositiva(false);
      }
    };

    getConfig();
  }, [queryParams.empresa_cnpj]);

  useEffect(() => {
    try {
      const columnsSubitem = [
        {
          id: "acoes",
          label: "Ações",
          align: "center",
          style: { width: 160 },
        },
        {
          id: "ambito",
          label: "Âmbito",
        },
        {
          id: "cnd",
          label: "Certidão",
        },
        { id: "consulta", label: "Consulta", align: "center" },
        {
          id: "icon",
          label: "Situação",
          align: "center",
        },
        {
          id: "data_emissao",
          label: "Emissão",
          align: "center",
        },
        {
          id: "data_vencimento",
          label: "Vencimento",
          align: "center",
        },
      ];

      const optionsIcons = {
        "Positiva Negativa": (
          <Tooltip title="Positiva com efeitos de Negativa">
            <CheckCircleIcon className="color-green" />
          </Tooltip>
        ),
        Negativa: (
          <Tooltip title="Negativa">
            <CheckCircleIcon className="color-green" />
          </Tooltip>
        ),
        Positiva: (
          <Tooltip title="Positiva">
            <CancelIcon className="color-red" />
          </Tooltip>
        ),
        Falha: (
          <Tooltip title="Falha">
            <ErrorIcon className="color-yellow" />
          </Tooltip>
        ),
        Erro: (
          <Tooltip title="Falha">
            <ErrorIcon className="color-yellow" />
          </Tooltip>
        ),

        Processando: (
          <Tooltip title="Processando">
            <PulseIcon>
              <TimerIcon className="color-black" />
            </PulseIcon>
          </Tooltip>
        ),
        "Positiva NegativaaVencer": (
          <Tooltip title="Positiva com efeitos de Negativa a vencer">
            <AccessAlarmsIcon className="color-green" />
          </Tooltip>
        ),
        NegativaaVencer: (
          <Tooltip title="Negativa a vencer">
            <AccessAlarmsIcon className="color-green" />
          </Tooltip>
        ),
        PositivaaVencer: (
          <Tooltip title="Positiva a vencer">
            <AccessAlarmsIcon className="color-red" />
          </Tooltip>
        ),
        FalhaaVencer: (
          <Tooltip title="Falha a vencer">
            <AccessAlarmsIcon className="color-yellow" />
          </Tooltip>
        ),
        ErroaVencer: (
          <Tooltip title="Falha a vencer">
            <AccessAlarmsIcon className="color-yellow" />
          </Tooltip>
        ),
        aVencer: (
          <Tooltip title="A vencer">
            <AccessAlarmsIcon className="color-black" />
          </Tooltip>
        ),
        "Positiva NegativaVencida": (
          <Tooltip title=" Positiva com efeitos de Negativa vencida">
            <EventBusyIcon className="color-green" />
          </Tooltip>
        ),
        NegativaVencida: (
          <Tooltip title="Negativa vencida">
            <EventBusyIcon className="color-green" />
          </Tooltip>
        ),
        PositivaVencida: (
          <Tooltip title="Positiva vencida">
            <EventBusyIcon className="color-red" />
          </Tooltip>
        ),
        FalhaVencida: (
          <Tooltip title="Falha vencida">
            <EventBusyIcon className="color-yellow" />
          </Tooltip>
        ),
        ErroVencida: (
          <Tooltip title="Falha vencida">
            <EventBusyIcon className="color-yellow" />
          </Tooltip>
        ),
        Vencida: (
          <Tooltip title="Vencida">
            <EventBusyIcon className="color-black" />
          </Tooltip>
        ),
      };

      const openMsgError = (msg = "") => {
        Swal.fire({
          icon: "warning",
          text: `Motivo da falha: ${msg}`,
          showConfirmButton: true,
        });
      };

      const handleClickManual = (rowSub) => {
        push("manual", JSON.stringify(rowSub));
      };

      const showFile = (file) => {
        if (!file || typeof file !== "string" || file.indexOf("data:") === -1) {
          return;
        }

        const contentType = file.substring(
          file.split("").findIndex((e) => e === ":") + 1,
          file.split("").findIndex((e) => e === ";")
        );

        const byteCharacters = atob(
          file.substr(`data:${contentType};base64,`.length)
        );

        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
          const slice = byteCharacters.slice(offset, offset + 1024);

          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);

          byteArrays.push(byteArray);
        }
        const blob = new Blob(byteArrays, { type: contentType });
        const blobUrl = URL.createObjectURL(blob);

        window.open(blobUrl, "_blank");
      };

      const downloadFile = (file) => {
        if (!file || typeof file !== "string") return;

        try {
          var element = document.createElement("a");

          element.setAttribute(
            "href",
            "data:application/octet-stream;base64," +
              encodeURIComponent(
                file.substring(file.split("").findIndex((e) => e === ",") + 1)
              )
          );

          element.setAttribute(
            "download",
            `CND.${file.substring(
              file.split("").findIndex((e) => e === "/") + 1,
              file.split("").findIndex((e) => e === ";")
            )}`
          );

          element.style.display = "none";
          document.body.appendChild(element);

          element.click();

          document.body.removeChild(element);

          return true;
        } catch (error) {
          console.error("error ButtonsAccountant executeDownload:", error);
          return false;
        }
      };

      const mapAllFiles = (items, option, email) => {
        if (!items || !option) return;

        if (option === "sendEmail") {
          sendEmail(items, email);
          return;
        }

        if (option === "refresh") {
          const idsToRefresh = [];
          let allProcessing = true;
          let allDisabled = true;

          items.forEach((item) => {
            if (
              allProcessing &&
              item.tipo_consulta === "Automática" &&
              item.status !== "Processando"
            ) {
              allProcessing = false;
            }

            if (!item.disabledRefresh) {
              allDisabled = false;
            }

            if (
              !item.disabledRefresh &&
              item.id &&
              item.tipo_consulta === "Automática" &&
              item.status !== "Processando"
            ) {
              idsToRefresh.push(item.id);
            }
          });

          if (allProcessing) {
            return notify(
              "Todas as CNDs automáticas selecionadas já estão em processamento, aguarde a finalização."
            );
          }

          if (allDisabled) {
            return notify("Todas as CNDs deste cliente estão em manutenção.");
          }

          if (idsToRefresh.length) refreshFile(idsToRefresh);
          return;
        }

        const optionsFunctions = {
          show: showFile,
          download: downloadFile,
        };

        items.map((item) => {
          optionsFunctions[option](item.file_base64);
          return null;
        });
      };

      const refreshFile = async (ids, force = false) => {
        try {
          setLoadindScreen(true);

          const result = await refreshCNDAgendaCliente(
            { agenda_clientes: ids },
            queryParams.empresa_cnpj,
            force
          );

          if (result.success) {
            Swal.fire({
              icon: "success",
              text: "Foi soliticada a atualização das CNDs automáticas com o status diferente de processando.",
              timer: 7000,
            });

            window.location.reload();
          }
        } catch (error) {
          notify("Não foi possível atualizar a CND.");
        } finally {
          setLoadindScreen(false);
        }
      };

      const sendEmail = (items, email) => {
        const filesToSend = [];

        const statusAccess = [];
        if (cndNegativaCheck) statusAccess.push("Negativa");
        if (cndPositivaCheck) statusAccess.push("Positiva");

        items.forEach((item) => {
          if (item.file_base64 && statusAccess.includes(item.status))
            filesToSend.push(item.file_base64);
        });

        if (!filesToSend || filesToSend.length < 1) {
          return notify(
            "As CNDs selecionadas não respeitam as configurações de envio."
          );
        }

        setFilesSendEmail(filesToSend);
        setEmailToSendEmail(email || "");
        setOpenSendEmail(true);
      };

      const constructorRows = async () => {
        let dataRowsCopy = [];

        try {
          setLoadingData(true);
          const { data } = await findCNDAgendaCliente(queryParams.empresa_cnpj);
          if (data && Array.isArray(data)) {
            let lastPage = data.length / rowsPerPage;
            if (initialPage > lastPage) {
              setInitialPage(parseInt(lastPage));
            }
            dataRowsCopy = [...data];
          }
        } catch (error) {
          notify("Não foi possível obter os dados.");
          console.error("error useEffect CNDTabControle 1", error);
        } finally {
          setLoadingData(false);
        }

        dataRowsCopy.forEach((row, index) => {
          row.cnds = row.cnds || [];
          row.total = row.cnds.length;
          row.Negativa = 0;
          row.Falha = 0;
          row.Positiva = 0;
          row.aVencer = 0;
          row.Vencida = 0;

          row.cnds.forEach((rowSub) => {
            rowSub.icon =
              optionsIcons[
                (rowSub.status || "") +
                  (rowSub.situacao && rowSub.status !== "Processando"
                    ? rowSub.situacao
                    : "")
              ];
            rowSub.status =
              rowSub.status === "Positiva Negativa"
                ? "Negativa"
                : rowSub.status;
            rowSub.ambito = rowSub.agenda.ambito;
            rowSub.tipo_consulta = rowSub.agenda.tipo_consulta;
            rowSub.cnd = rowSub.agenda.cnd.cnd;

            rowSub.data_emissao = rowSub.data_emissao
              ? rowSub.data_emissao.split("-").reverse().join("/")
              : "";
            rowSub.data_vencimento = rowSub.data_vencimento
              ? rowSub.data_vencimento.split("-").reverse().join("/")
              : "";

            row[rowSub.status === "Erro" ? "Falha" : rowSub.status] =
              row[rowSub.status === "Erro" ? "Falha" : rowSub.status] + 1;
            row[rowSub.situacao] = row[rowSub.situacao] + 1;

            rowSub.disabledRefresh = false;

            if (!Array.isArray(rowSub.cnds_agendas_clientes_falhas)) {
              rowSub.cnds_agendas_clientes_falhas = [];
            }

            if (rowSub.cnds_agendas_clientes_falhas.length > 10) {
              const lastFailed = Math.max(
                ...rowSub.cnds_agendas_clientes_falhas.map((f) => {
                  if (f.created_at) {
                    const date = new Date(f.created_at);

                    return date.setDate(date.getDate() + 7);
                  }

                  return 0;
                })
              );

              rowSub.disabledRefresh = Date.parse(new Date()) < lastFailed;
            }

            rowSub.acoes = (
              <div className="min-width-actions">
                <Tooltip title="Abrir em outra aba">
                  <VisibilityIcon
                    disabled={rowSub.file_base64 ? false : true}
                    className="icon-action-with-margin"
                    onClick={() => {
                      if (["Erro", "Falha"].includes(rowSub.status)) {
                        return openMsgError(rowSub.response_json);
                      }
                      showFile(rowSub.file_base64);
                    }}
                  />
                </Tooltip>

                <Tooltip title="Download">
                  <CloudDownloadIcon
                    disabled={rowSub.file_base64 ? false : true}
                    className="icon-action-with-margin"
                    onClick={() => downloadFile(rowSub.file_base64)}
                  />
                </Tooltip>

                <Tooltip
                  title={
                    rowSub.disabledRefresh
                      ? "CND em manuntenção"
                      : "Atualizar arquivo"
                  }
                >
                  <RefreshIcon
                    disabled={
                      rowSub.disabledRefresh || rowSub.status === "Processando"
                    }
                    className={
                      rowSub.disabledRefresh
                        ? "icon-action-red"
                        : "icon-action-with-margin"
                    }
                    onClick={() => {
                      if (
                        rowSub.disabledRefresh ||
                        rowSub.status === "Processando"
                      )
                        return notify(
                          "A CND selecionada já está em processamento, aguarde a finalização."
                        );

                      if (rowSub.tipo_consulta === "Manual") {
                        return rowSub.file_base64
                          ? handleClickManual(Object.assign(row, rowSub))
                          : null;
                      } else if (rowSub.status === "Processando") {
                        Swal.fire({
                          icon: "question",
                          text: "A CND já está em processamento, tem certeza que deseja solicita-la novamente?",
                          showConfirmButton: true,
                          showCancelButton: true,
                        }).then(async (result) => {
                          if (result.isConfirmed) {
                            refreshFile([rowSub.id], true);
                          }
                        });

                        return;
                      }

                      refreshFile([rowSub.id]);
                    }}
                  />
                </Tooltip>

                <Tooltip title="Enviar por e-mail">
                  <SendIcon
                    className="icon-action-with-margin"
                    onClick={() =>
                      sendEmail(rowSub.file_base64 ? [rowSub] : [], row.email)
                    }
                  />
                </Tooltip>

                {!!rowSub.cnds_agendas_clientes_falhas.length && (
                  <Tooltip title="Visualizar datas das falhas">
                    <ErrorOutlineIcon
                      className="icon-action"
                      onClick={() => {
                        setOpenCndFailure(true);
                        setArrCndFailures(rowSub.cnds_agendas_clientes_falhas);
                      }}
                    />
                  </Tooltip>
                )}
              </div>
            );

            if (rowSub.tipo_consulta === "Manual") {
              if (rowSub.file_base64) {
                rowSub.consulta = (
                  <label>
                    Manual
                    <CheckIcon />
                  </label>
                );
              } else {
                rowSub.consulta = (
                  <Tooltip title="Anexar CND manual">
                    <label
                      className="label-manual"
                      onClick={() =>
                        handleClickManual(Object.assign(row, rowSub))
                      }
                    >
                      Manual <AttachFileIcon />
                    </label>
                  </Tooltip>
                );
              }
            } else rowSub.consulta = rowSub.tipo_consulta;
          });

          if (row.cnpj_cpf && typeof row.cnpj_cpf === "string") {
            row.cnpj_cpf = row.cnpj_cpf.replace(/[^0-9]+/g, "");

            row.cnpj_cpf = MaskService.toMask(
              row.cnpj_cpf.length < 12 ? "cpf" : "cnpj",
              row.cnpj_cpf
            );
          } else row.cnpj_cpf = "";

          if (row.Negativa) {
            row.Negativa = (
              <Tooltip title="Negativa">
                <div className="container-icon-and-number">
                  <CheckCircleIcon className="color-green" />
                  {row.Negativa}
                </div>
              </Tooltip>
            );
          } else row.Negativa = row.Negativa || "";

          if (row.Falha) {
            row.Falha = (
              <Tooltip title="Falha">
                <div className="container-icon-and-number">
                  <ErrorIcon className="color-yellow" />
                  {row.Falha}
                </div>
              </Tooltip>
            );
          } else row.Falha = row.Falha || "";

          if (row.Positiva) {
            row.Positiva = (
              <Tooltip title="Positiva">
                <div className="container-icon-and-number">
                  <CancelIcon className="color-red" />
                  {row.Positiva}
                </div>
              </Tooltip>
            );
          } else row.Positiva = row.Positiva || "";

          if (row.aVencer) {
            row.aVencer = (
              <Tooltip title="A vencer">
                <div className="container-icon-and-number">
                  <AccessAlarmsIcon className="color-black" />
                  {row.aVencer}
                </div>
              </Tooltip>
            );
          } else row.aVencer = row.aVencer || "";

          if (row.Vencida) {
            row.Vencida = (
              <Tooltip title="Vencida">
                <div className="container-icon-and-number">
                  <EventBusyIcon className="color-black" />
                  {row.Vencida}
                </div>
              </Tooltip>
            );
          } else row.Vencida = row.Vencida || "";

          row.acoes = (
            <div className="min-width-actions">
              <Tooltip title="Abrir em outra aba">
                <VisibilityIcon
                  className="icon-action-with-margin"
                  onClick={() => mapAllFiles(row.cnds, "show", row.email)}
                />
              </Tooltip>

              <Tooltip title="Download">
                <CloudDownloadIcon
                  className="icon-action-with-margin"
                  onClick={() => mapAllFiles(row.cnds, "download", row.email)}
                />
              </Tooltip>

              <Tooltip title="Atualizar arquivo">
                <RefreshIcon
                  className="icon-action-with-margin"
                  onClick={() => mapAllFiles(row.cnds, "refresh", row.email)}
                />
              </Tooltip>

              <Tooltip title="Enviar por e-mail">
                <SendIcon
                  className="icon-action"
                  onClick={() => mapAllFiles(row.cnds, "sendEmail", row.email)}
                />
              </Tooltip>
            </div>
          );

          if (row.cnds && row.cnds.length > 0) {
            row.subitemTable = (
              <TableDefault
                key={index}
                columns={columnsSubitem}
                tableTitle=""
                values={row.cnds.sort((a, b) => a.id - b.id)}
                rowsPerPage={rowsPerPage}
              />
            );
          } else {
            row.subitemTable = <label>Não há registros</label>;
          }
        });

        setDataRows(dataRowsCopy);
        setDataRowsFilter(dataRowsCopy);
      };

      constructorRows();
    } catch (error) {
      notify("Não foi possível construir a tela.");
      console.error("error useEffect CNDTabControle 2");
    }
    // eslint-disable-next-line
  }, [rowsPerPage, push, queryParams.empresa_cnpj, refreshData]);

  const handleChangeSendAutomatic = async () => {
    try {
      setLoadingSendAuto(true);
      const result = await updateCNDConfig(
        queryParams.empresa_cnpj,
        "email_automatico",
        !envioAutomaticoCheck ? true : ""
      );

      if (result && result.success) setEnvioAutomaticoCheck((prev) => !prev);
    } catch (error) {
    } finally {
      setLoadingSendAuto(false);
    }
  };

  const handleChangeCNDNegative = async () => {
    try {
      setLoadingCheckCndNegativa(true);
      const result = await updateCNDConfig(
        queryParams.empresa_cnpj,
        "acesso_cnd_negativa",
        !cndNegativaCheck ? true : ""
      );

      if (result && result.success) setCndNegativaCheck((prev) => !prev);
    } catch (error) {
    } finally {
      setLoadingCheckCndNegativa(false);
    }
  };

  const handleChangeCNDPositive = async () => {
    try {
      setLoadingCheckCndPositiva(true);
      const result = await updateCNDConfig(
        queryParams.empresa_cnpj,
        "acesso_cnd_positiva",
        !cndPositivaCheck ? true : ""
      );

      if (result && result.success) setCndPositivaCheck((prev) => !prev);
    } catch (error) {
    } finally {
      setLoadingCheckCndPositiva(false);
    }
  };

  const handleChangeAccessPass = async () => {
    try {
      setLoadingAccessPass(true);
      const result = await updateCNDConfig(
        queryParams.empresa_cnpj,
        "acesso_cliente_qyon_pass",
        !acessoClienteCheck ? true : ""
      );

      if (result && result.success) setAcessoClienteCheck((prev) => !prev);
    } catch (error) {
    } finally {
      setLoadingAccessPass(false);
    }
  };

  const handleChangeFilter = (e) => {
    if (!e) return setDataRowsFilter(dataRows);
    const newArr = filterTable({
      data: dataRows,
      text: e.target.value,
      columns: ["cnpj_cpf", "razao"],
    });
    setDataRowsFilter(newArr);
  };

  const defaultTableColumns = [
    {
      id: "acoes",
      label: "Ações",
      align: "center",
      style: { width: 130 },
    },
    {
      id: "cnpj_cpf",
      label: "Nº Inscrição",
      style: { width: 130 },
    },
    {
      id: "razao",
      label: "Razão Social",
    },
    { id: "total", label: "Total", align: "center", style: { width: 50 } },
    {
      id: "Negativa",
      label: "Negativa",
      align: "center",
      style: { width: 50 },
    },
    {
      id: "Falha",
      label: "Falha",
      align: "center",
      style: { width: 50 },
    },
    {
      id: "Positiva",
      label: "Positiva",
      align: "center",
      style: { width: 50 },
    },
    {
      id: "aVencer",
      label: "A Vencer",
      align: "center",
      style: { width: 90 },
    },
    {
      id: "Vencida",
      label: "Vencida",
      align: "center",
      style: { width: 50 },
    },
  ];

  return (
    <>
      <Loading open={loadingScreen} />
      {openSendEmail && (
        <CNDSendEmail
          openSendEmail={openSendEmail}
          setOpenSendEmail={setOpenSendEmail}
          files={filesSendEmail}
          email={emailToSendEmail}
        />
      )}

      {openCndFailure && (
        <CNDFailure
          setOpenCndFailure={setOpenCndFailure}
          arrCndFailures={arrCndFailures}
        />
      )}

      <TableDefault
        initialPage={initialPage}
        setInitialPage={setInitialPage}
        loading={loadingData}
        columns={defaultTableColumns}
        tableTitle={
          <div className="container-checkbox-controle">
            <Grid
              container
              direction="row"
              justify="space-between"
              alignItems="center"
              spacing={4}
            >
              <Grid item flex={1}>
                Controle de todas as CNDs cadastradas
              </Grid>

              <Grid item flex={1}>
                <Grid item>
                  <FormControlLabel
                    control={
                      <>
                        {loadingSendAuto ? (
                          <CircularProgress className="loading-check-cnd" />
                        ) : (
                          <Switch
                            checked={envioAutomaticoCheck}
                            onChange={handleChangeSendAutomatic}
                          />
                        )}
                      </>
                    }
                    label="Envio automático por e-mail"
                  />
                </Grid>
                <Grid item>
                  <FormControlLabel
                    control={
                      <>
                        {loadingAccessPass ? (
                          <CircularProgress className="loading-check-cnd" />
                        ) : (
                          <Switch
                            checked={acessoClienteCheck}
                            onChange={handleChangeAccessPass}
                          />
                        )}
                      </>
                    }
                    label="Acesso ao cliente através do Portal"
                  />
                </Grid>

                <Grid item container justify="center">
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ marginTop: 15, marginBottom: 15, width: "100%" }}
                    startIcon={<RefreshIcon />}
                    onClick={() => window.location.reload()}
                  >
                    Atualizar Status das Consultas
                  </Button>
                </Grid>
              </Grid>

              <Grid item flex={1}>
                <Grid
                  item
                  container
                  direction="column"
                  justify="center"
                  alignItems="center"
                  className="container-check-cnd"
                >
                  <Grid item>
                    <FormControlLabel
                      className="padding-left-10"
                      control={
                        <>
                          {loadingCheckCndPositiva ? (
                            <CircularProgress className="loading-check-cnd" />
                          ) : (
                            <Checkbox
                              checked={cndPositivaCheck}
                              onChange={handleChangeCNDPositive}
                              name="cndPositivaCheck"
                              color="primary"
                            />
                          )}
                        </>
                      }
                      label="CNDs Positivas"
                    />
                  </Grid>
                  <Grid item>
                    <FormControlLabel
                      className="padding-left-16"
                      control={
                        <>
                          {loadingCheckCndNegativa ? (
                            <CircularProgress className="loading-check-cnd" />
                          ) : (
                            <Checkbox
                              checked={cndNegativaCheck}
                              onChange={handleChangeCNDNegative}
                              name="cndNegativaCheck"
                              color="primary"
                            />
                          )}
                        </>
                      }
                      label="CNDs Negativas"
                    />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item container xs={12}>
                <Grid item lg={5} md={8} sm={12} xs={12}>
                  <SearchInput
                    disabled={loadingData}
                    handleChange={handleChangeFilter}
                    placeholder="Pesquisar por Nº de Inscrição e Razão Social"
                  />
                </Grid>
              </Grid>
            </Grid>
          </div>
        }
        values={dataRowsFilter}
        subitemTable={!loadingData}
        rowsPerPage={rowsPerPage}
      />
    </>
  );
};

export default CNDTabControle;
